module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","campaign":"Kampagne","dashboard":"Dashboard","save":"Speichern","thereAreItemsThatRequireYourAttention":"Es gibt Felder, die Ihre Aufmerksamkeit erfordern."},"en":{"back":"Back","campaign":"Campaign","dashboard":"Dashboard","save":"Save","thereAreItemsThatRequireYourAttention":"There are items that require your attention."}}')
  delete Component.options._Ctor
}
